import type { TimelineItem } from "@/mocks/cases";

export default function CaseTimeline({ items }: { items: TimelineItem[] }) {
  return (
    <section id="timeline" className="scroll-mt-24">
      <div className="flex items-center gap-3 mb-5">
        <span className="flex w-10 h-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
          <i className="ri-timer-line text-lg" />
        </span>
        <div>
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950">事件时间线</h2>
          <p className="text-xs text-foreground-500">按公开时间戳排列 · 共 {items.length} 个节点</p>
        </div>
      </div>

      <ol className="relative rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
        <span className="absolute left-[27px] md:left-[35px] top-9 bottom-9 w-px bg-background-300" aria-hidden="true" />
        {items.map((node, index) => (
          <li key={`${node.time}-${index}`} className="relative flex gap-4 pb-6 last:pb-0">
            <span
              className={`relative z-10 mt-0.5 flex w-[15px] h-[15px] shrink-0 items-center justify-center rounded-full ${
                index === items.length - 1 ? "bg-accent-500" : "bg-primary-500"
              }`}
            >
              <span className="w-1.5 h-1.5 rounded-full bg-background-50" />
            </span>
            <div className="min-w-0">
              <p className="text-xs font-medium tracking-wide text-foreground-500">{node.time}</p>
              <p className="mt-1 text-sm leading-relaxed text-foreground-800">{node.event}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}